import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { IntStringRequest } from "./IntStringRequest";
import { MealModifyRequest } from "./MealModifyRequest";
import { MealNameRequest } from "./MealNameRequest";

@Injectable()
export class DataService_MealType {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	MealTypeSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealTypeSelectList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealNameUsed(parms: MealNameRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealNameUsed";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealCostSelectList(MealID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealCostSelectList?MealID=" + MealID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealInsert(parms: MealModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealUpdate(parms: MealModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealToggle(MealID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealToggle?MealID=" + MealID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealDelete(MealID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/MealDelete?MealID=" + MealID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
